







import Vue from 'vue'
import { getSpiderDailyStats } from '@/core/api/spider-stats.ts'
import LineChart from '@/components/charts/line-chart.vue'

export default Vue.extend({
  components: {
    LineChart,
  },
  props: {
    'spiderId': {
      type: String,
      default: null,
    },
  },
  data: () => ({
    items: [],
    loading: false,
  }),
  computed: {
    chart(): Record<string, any> {
      return {
        labels: this.items.map(x => x['date']),
        datasets: [
          {
            label: 'Запросов к сайту',
            borderColor: '#f6b36d',
            backgroundColor: '#f6b36d33',
            fill: false,
            data: this.items.map(x => x['total_pages']),
          },
          {
            label: 'Собрано страниц',
            borderColor: '#bad0af',
            backgroundColor: '#bad0af33',
            fill: true,
            data: this.items.map(x => x['valid_pages']),
          },
          {
            label: 'Новостей за сутки',
            borderColor: '#488f31',
            backgroundColor: '#488f3133',
            data: this.items.map(x => x['unique_pages']),
          },
        ],
      }
    },
    options(): Record<string, any> {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                reverse: true,
                beginAtZero: true,
                maxRotation: 90,
                minRotation: 70,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                maxRotation: 45,
                minRotation: 45,
              },
            },
          ],
        },
      }
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      if (this.spiderId == null) {
        return
      }

      this.loading = true
      getSpiderDailyStats(this.spiderId)
        .then(({ data }) => {
          this.items = data['results']
        })
        .catch(() => {
          this.$toastError.fire()
        })
        .finally(() => {
          this.loading = false
        })

      this.loading = false
    },
  },
})
